import { AppState } from '../index';

export const getAuthState = (state : AppState) => state.auth.authState;
export const getUserIdentity = (state : AppState) => state.auth.userIdentity;
